export default "__VITE_ASSET__wYrU3Mvv__"